import wrapWithProvider from './wrap-with-provider';
import { PageWrapper } from './wrap-page-element';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = PageWrapper;

export const onClientEntry = () => {
  require('regenerator-runtime');
};
